var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImageDucEditImage = function SvgImageDucEditImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.623.024c.66.086 1.352.408 2.044 1.064 1.414 1.338 1.488 2.817 1.193 3.941a5.264 5.264 0 0 1-.92 1.854l-.007.008-.002.003v.001s-.001.001-.326-.28l.325.281-.01.012L6.96 18.289.75 19.98c-.443.12-.847-.293-.73-.744l1.655-6.33 10.7-11.35a4.683 4.683 0 0 1 .402-.439c.26-.249.643-.56 1.121-.791a3.038 3.038 0 0 1 1.725-.301ZM12.71 2.453 2.654 13.12l4.083 4.164L16.999 6.625 12.71 2.453ZM5.917 17.675l-3.638-3.71-1.322 5.06 4.96-1.35ZM13.29 1.818l4.252 4.136.023-.038c.164-.276.355-.662.473-1.111.23-.876.19-2.002-.95-3.08-.584-.553-1.116-.78-1.572-.84-.46-.06-.883.045-1.254.224a3.584 3.584 0 0 0-.972.709Z",
    fill: "#000"
  })));
};
export default SvgImageDucEditImage;